import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CreateUserPageComponent from "./components/CreateUserPageComponent";

const AdminCreateUserPage = () => {
  const [userUpdated, setUserUpdated] = useState()
  const [userDetails, setUserDetails] = useState()

  const dispatch = useDispatch();
  const getAlldeliveryBooks = async () => {
    const { data } = await axios.get("/api/deliveryBooks");
    return data;
  };

  // const getdeliveryBooks = async (email) => {
  //   const { data } = await axios.get("/api/deliveryBooks/deliveryBook/" + email);
  //   return data;
  // };

  const getAllUniformRole = async () => {
    const { data } = await axios.get("/api/uniformRoles");
    return data;
  }

  const getUniformRoleByRole = async (role) => {
    const { data } = await axios.get(`/api/uniformRoles/get-one/${role}`);
    return data;
  }

  const createUserApiRequest = async (
    // accountType,
    name,
    lastName,
    email,
    password,
    phone,
    mobile,
    ipAddress,
    isAdmin,
    verified,
    isPD,
    isSiteManager,
    isSitePerson,
    company,
    location,
    isSales,
    isMarketing,
    isDeveloper,
    isSuperAdmin,
    isExtSales,
    isNewUser,
    isVIP,
    isCreditVerified,
    accounts,
    abn,
    role,
    contacted,
    contactedDate,
    notes
  ) => {
    const { data } = await axios.post(`/api/users/createUser`, {
      // accountType,
      name,
      lastName,
      email,
      password,
      phone,
      mobile,
      ipAddress,
      isAdmin,
      verified,
      isPD,
      isSiteManager,
      isSitePerson,
      company,
      location,
      isSales,
      isMarketing,
      isDeveloper,
      isSuperAdmin,
      isExtSales,
      isNewUser,
      isVIP,
      isCreditVerified,
      accounts,
      abn,
      role,
      contacted,
      contactedDate,
      notes
    });
    setUserUpdated(data)
    setUserDetails({ "userName": name + " " + lastName, "company": company, "role": role })
    return data;
  };

  const createUniformUserRole = async (role) => {
    const { data } = await axios.post("/api/uniformRoles/admin", {
      role,
      limits: [
        { itemName: "SHIRTS", itemLimit: 3 },
        { itemName: "JACKETS", itemLimit: 3 },
        { itemName: "PANTS", itemLimit: 3 },
        { itemName: "OVERALLS", itemLimit: 3 },
        { itemName: "BOOTS", itemLimit: 3 },
      ],
    })
    return data;
  }

  return (
    <CreateUserPageComponent
      createUserApiRequest={createUserApiRequest}
      getAllUniformRole={getAllUniformRole}
      getAlldeliveryBooks={getAlldeliveryBooks}
      getUniformRoleByRole={getUniformRoleByRole}
      createUniformUserRole={createUniformUserRole}
    />
  );
};

export default AdminCreateUserPage;